<!-- Send Shipping Mail Modal -->
<div class="modal fade" id="kt_modal_send_shipping_mail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header p-3 d-flex justify-content-between bg-primary">
        <h2 class="fw-bold m-0 text-white">
          <i class="ki-duotone ki-sms fs-2 text-white me-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Send Shipping Documents
        </h2>
        <div class="btn btn-icon btn-sm btn-active-icon-light" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1 text-white">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body scroll-y mx-5 mx-xl-10 my-7">
        <form [formGroup]="mailForm" id="kt_modal_send_shipping_mail_form">
          <!-- Selected Shippings Info -->
          <div class="mb-7">
            <div class="alert alert-info d-flex align-items-start">
              <i class="ki-duotone ki-information-5 fs-2 text-info me-3 mt-1">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              <div class="flex-grow-1">
                <div class="fw-bold fs-6 mb-2">Selected Shippings ({{ selectedInvoices.length }})</div>
                <div class="text-gray-700 fs-7">
                  <div class="mb-2">
                    <span class="fw-semibold">Stock Numbers:</span>
                    <div class="mt-1 text-break">{{ getCarNumbers() || 'N/A' }}</div>
                  </div>
                  <div class="mb-2">
                    <span class="fw-semibold">Vehicle Names:</span>
                    <div class="mt-1 text-break">{{ getCarNames() || 'N/A' }}</div>
                  </div>
                  <div>
                    <span class="fw-semibold">Documents:</span>
                    <div class="mt-1 text-break">{{ getDocumentTypeLabels() }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Email Input -->
          <div class="mb-7">
            <label class="required form-label fw-semibold fs-6">Email Address</label>
            <input
              type="email"
              class="form-control form-control-solid"
              placeholder="Enter email address"
              formControlName="email"
              [class.is-invalid]="mailForm.get('email')?.invalid && mailForm.get('email')?.touched" />
            <div class="invalid-feedback" *ngIf="mailForm.get('email')?.invalid && mailForm.get('email')?.touched">
              <div *ngIf="mailForm.get('email')?.errors?.['required']">Email is required</div>
              <div *ngIf="mailForm.get('email')?.errors?.['email']">Please enter a valid email address</div>
            </div>
            <div class="form-text" *ngIf="!mailForm.get('email')?.disabled">
              Enter the recipient's email address to send the shipping documents
            </div>
            <div class="form-text text-primary" *ngIf="mailForm.get('email')?.disabled">
              <i class="ki-duotone ki-information-5 fs-6 me-1">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              Email pre-filled from shipping company
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex justify-content-end gap-3">
            <button
              type="button"
              class="btn btn-light"
              data-bs-dismiss="modal"
              [disabled]="isSending">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="onSendMail()"
              [disabled]="isSending || !isFormValid()">
              <span *ngIf="isSending" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              <i *ngIf="!isSending" class="ki-duotone ki-send fs-2 me-1">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              {{ isSending ? 'Sending...' : 'Send Mail' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
